<mat-action-list class="template-list"
                 cdkDropList
                 [cdkDropListLockAxis]="'y'"
                 (cdkDropListSorted)="swapTemplates($event)"
                 (cdkDropListDropped)="setNewTemplateOrder($event)">

    <template-versions cdkDrag
                       class="drag-drop-template"
                       *ngFor="let template of categoryTemplateList.items; let idx = index"
                       [idPrefix]="(idPrefix + 'template_' + idx + '.')"
                       [(categoryTemplateList)]="categoryTemplateList"
                       [template]="template"
                       [caseFileCategories]="categoryTemplateList.document_types">
    </template-versions>

</mat-action-list>

<div class="row">
    <div class="col-12 text-right">
        <file-select [idPrefix]="idPrefix"
                     [acceptedFiles]="acceptedFilesTypes"
                     [label]="'template_management.btn.add_template' | translate | uppercase"
                     [multi]="false"
                     (filesSelected)="createTemplate($event)">
        </file-select>
    </div>
</div>
